import React from "react";
import { connect } from "react-redux";
import { getDealNotes, addNoteToDeal, deleteNote } from "store/state/deal";
import NotesDrawer from "components/Global/Notes/NotesDrawer";
import _ from "lodash";

class DealNotes extends React.Component {

  componentDidUpdate(prevProps, prevState) {
    const { dealId, isOpen } = this.props;
    const { isOpen: prevIsOpen } = prevProps;

    if (isOpen !== prevIsOpen && isOpen) {
      this.props.getDealNotes({
        modelName: "deal",
        modelId: dealId,
        subKey: dealId
      });
    }
  }

  handleRemove = noteId => {
    const { dealId } = this.props;

    this.props.deleteNote({
      noteId: noteId,
      shouldUpdateAfter: true,
      modelName: "deal",
      modelId: dealId,
      subKey: dealId
    });
  };

  render() {
    const { isOpen, closeNotes, dealNotes, dealId, addNoteToDeal } = this.props;
    const specificDealNotes = dealNotes[dealId] || [];

    return (
      <React.Fragment>
        <NotesDrawer
          addNote={note => addNoteToDeal("deal", dealId, note)}
          isOpen={isOpen}
          closeDrawer={closeNotes}
          notes={specificDealNotes}
          handleRemove={this.handleRemove}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ deal }) => ({
  dealNotes: deal.dealNotes
});

export default connect(
  mapStateToProps,
  {
    getDealNotes,
    addNoteToDeal,
    deleteNote
  }
)(DealNotes);
